<ng-container *ngIf="showQuantitySelector; then inTrolley; else notInTrolley"></ng-container>

<ng-template #inTrolley>
	<product-quantity-selector
		[@animation]
		[id]="id"
		[unit]="unit"
		[averageWeightPerUnit]="averageWeightPerUnit"
		[layout]="layout"
		[quantityResponse]="quantityResponse"
		(incrementEmitter)="updateQuantityClick($event)"
		(decrementEmitter)="updateQuantityClick($event)"
		(updateEmitter)="updateQuantityClick($event)"
	>
	</product-quantity-selector>
</ng-template>
<ng-template #notInTrolley>
	<button
		[@animation]
		class="addToTrolley-btn--add"
		attr.data-cy="addToTrolleyBtn"
		cdxButton
		[buttonState]="buttonState"
		[disabled]="!productIsInStock"
		[fullWidth]="true"
		(animationCompletedEmitter)="addToTrolleyAnimationComplete()"
		(click)="addToTrolleyClick()"
		aria-live="polite"
		[attr.aria-label]="ariaButtonText"
	>
		{{ buttonText }}
		<ng-container completed>Added</ng-container>
	</button>
</ng-template>
